export default "__VITE_ASSET__tizjI_To__"